<section class="makePaymentPage__invoicesTable my-4">
  <div class="makePaymentPage__tableHeader container py-3">
    <div class="makePaymentPage__tableHeaderRow row d-none d-lg-flex">
      <div class="makePaymentPage__tableHeaderCell col-3">{{ 'makeAPayment.credit#' | cxTranslate }}</div>
      <div class="makePaymentPage__tableHeaderCell col-3">{{ 'makeAPayment.account#' | cxTranslate }}</div>
      <div class="makePaymentPage__tableHeaderCell col-3">{{ 'makeAPayment.credit_date' | cxTranslate }}</div>
      <div class="makePaymentPage__tableHeaderCell col-3">{{ 'makeAPayment.credit_amount' | cxTranslate }}</div>
    </div>
  </div>
  <div class="makePaymentPage__tableBody container">
    @if (isLoading()) {
      <app-loader/>
    } @else {
      @for (credit of creditList(); track credit.originalInvoice || credit.refDocNo) {
        <div class="makePaymentPage__tableRow row flex-column flex-lg-row my-3 py-4">
          <div class="makePaymentPage__tableCell col-12 col-lg-3 d-flex">
            <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.credit#' | cxTranslate }}: </div>
            <a href="javascript: void(0);" class="underline" (click)="invoicePdf(credit.originalInvoice || credit.refDocNo)">
              {{ credit.originalInvoice || credit.refDocNo }}
            </a>
          </div>

          <div class="makePaymentPage__tableCell col-12 col-lg-3 d-flex">
            <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.account#' | cxTranslate }}: </div>
            <span>{{ credit.customer }}</span>
          </div>

          <div class="makePaymentPage__tableCell col-12 col-lg-3 d-flex">
            <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.credit_date' | cxTranslate }}: </div>
            <span>{{ CommonUtils.formatDate(credit.blineDate, US_DATE_FORMAT, EU_DATE_FORMAT) }}</span>
          </div>

          <div class="makePaymentPage__tableCell col-12 col-lg-3 d-flex">
            <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.credit_amount' | cxTranslate }}: </div>
            <span>{{ credit.amount | currency }}</span>
          </div>
        </div>
      }

      <sanofi-no-items-disclaimer [itemsList]="creditList()" [text]="'makeAPayment.noCreditsToDisplay' | cxTranslate" [mix]="'makePaymentPage__tableRow'"/>
    }
  </div>
</section>
